import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


import './myprofile.css';

const MyProfile = () => {

    document.title = 'My profile - ZeroZero';

    const navigate = useNavigate();
    const [addressHistory, setAddressHistory] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const storedData = localStorage.getItem('userData') || ' {}';
    const userData = JSON.parse(storedData);
    const id = userData.id || null;
    const firstName = userData ? userData.FirstName : null;
    const lastName = userData ? userData.LastName : null;
    const email = userData ? userData.email : null;
    const mobile = userData ? userData.Mobile : null;

    useEffect(() => {
        resize();
    }, []);

    const resize = () => {
        if (document.body.offsetWidth <= 950) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    window.addEventListener('resize', resize);



    return (<div className='my-account-profile'>
        <div className='cont'>
            <h1>My Profile</h1>
            <div className='profile-sub'>
                <main>
                    <div className='rs'>
                        <h2>Profile Details</h2>
                        <section>
                            <span><b>Name: </b>{firstName} {lastName}</span>
                            <span><b>Email ID: </b>{email}</span>
                            <span><b>Phone Number: </b>{mobile}</span>
                        </section>
                    </div>
                </main>
         
            </div>
        </div>
   
    </div>);
}

export default MyProfile;
